module.exports = __webpack_public_path__ + "static/media/goal.0c03e430.svg";